import "prebid.js/modules/ixBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {IndexExchangeAdUnit} from "header-bidding-base/modules/config/domain/bidders/indexExchangeConfig";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";

export class IndexExchangeBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<IndexExchangeAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.INDEXEXCHANGE);
    }

    public override getBidderSettings() {
        const settings = super.getBidderSettings();

        if (settings) {
            settings[this.bidder].storageAllowed = true;
        }


        return settings;
    }
}
